//#region src/kiosk_pusher_state.ts
var KioskPusherState = /* @__PURE__ */ function(KioskPusherState) {
	KioskPusherState[KioskPusherState["Disconnected"] = 0] = "Disconnected";
	KioskPusherState[KioskPusherState["Connecting"] = 1] = "Connecting";
	KioskPusherState[KioskPusherState["Connected"] = 2] = "Connected";
	KioskPusherState[KioskPusherState["Subscribed"] = 3] = "Subscribed";
	return KioskPusherState;
}(KioskPusherState || {});
//#endregion
export { KioskPusherState };

//# sourceMappingURL=kiosk_pusher_state.js.map